import * as S from './styles';
import Icon, { IconType } from 'components/Icon';
import { useTheme } from 'styled-components';
import { displayGuestSignupModal } from 'redux/mode/util';

interface CtaButtonProps {
	minimal: boolean; // if true show a very narrow version of the button
}

const CtaButton = ({ minimal = false }: CtaButtonProps) => {
	const theme = useTheme();

	return (
		<S.Container>
			<S.Button onClick={() => displayGuestSignupModal()}>
				<S.IconWrapper>
					<Icon type={IconType.MOONCHILD} color={theme.gray[100]} width={20} height={20} />
				</S.IconWrapper>
				{!minimal && <S.Label>Request Access</S.Label>}
			</S.Button>
		</S.Container>
	);
};

export default CtaButton;
